// import { Text } from '@pancakeswap-libs/uikit'
import styled from 'styled-components'

export const Title = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #280D5F;
  line-height: 20px;
  padding: 28px 24px;
  background: linear-gradient(103deg, #F2ECF2, #E8F2F6);
`
export const InputBox = styled.div`
  margin-bottom: 20px;
`
export const InputTitle = styled.div`
  font-size: 14px;
  color: #280D5F;
  margin-bottom: 10px;
`
export const WarnTip = styled.div`
  font-size: 13px;
  color: #280D5F;
  line-height: 23px;
  padding: 15px 15px;
  background: #FFF6E8;
  border: 1px solid #FFC323;
  border-radius: 12px;
  margin-bottom: 20px;
`
export const Wrapper = styled.div`
  position: relative;
`
